import * as React from 'react';
import { WindowDimensionsContext, ScreenSize } from '@invitae/nucleobase-core';

function useWindowDimensions() {
    var currentScreenSize = React.useContext(WindowDimensionsContext);
    return {
        currentScreenSize: currentScreenSize,
        isExtraLarge: currentScreenSize === ScreenSize.ExtraLarge,
        isExtraSmall: currentScreenSize === ScreenSize.ExtraSmall,
        isLargeOrUp: currentScreenSize ? [ScreenSize.Large, ScreenSize.ExtraLarge].includes(currentScreenSize) : undefined,
        isMedium: currentScreenSize === ScreenSize.Medium,
        isMediumOrUp: currentScreenSize
            ? [ScreenSize.Medium, ScreenSize.Large, ScreenSize.ExtraLarge].includes(currentScreenSize)
            : undefined,
        isSmall: currentScreenSize === ScreenSize.Small,
    };
}

export { useWindowDimensions as default };
//# sourceMappingURL=useWindowDimensions.esm.js.map
